import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { postAwardsBlobApi, postCertificateBlobApi, postHealthBlobApi, postPersonalProfilCoverImageApi, getPersonalProfileApi, postPersonalProfilImageApi, getProfessionalInfoApi, postProfessionalProfilCoverImageApi, postProfessionalProfilImageApi, postProjectBlobApi, postServiceBlobApi, getVideoResumeApi, postEducationBlobApi, postExperienceBlobApi, postPersonalProfileApi, postPersonalProfileHobbiesApi, getPersonalProfileHobbiesApi, postPersonalProfileLanguagesApi, getPersonalProfileLanguagesApi, postPersonalProfileGenerateAboutMeApi, postPersonalProfileUpdateVisibilityApi, postPersonalProfileHealthApi, getPersonalProfileHealthApi, postPersonalProfileFamilyApi, getPersonalProfileFamilyApi, deletePersonalProfileFamilyApi, getProfileCompletionStatusApi, getProfileHealthDocumentsApi, getEducationApi, getCertificateApi, getExperienceApi, getProjectApi, getServiceApi, getAwardsApi, deleteResumeApi, getResumeApi, getProfessionalSkillsApi, postGenerateDescriptionApi, postProfessionalProfileApi, postProfessionalProfileGenerateAboutMeApi, postProfessionalSkillsApi, deleteEducationApi, deleteCertificateApi, deleteExperienceApi, deleteProjectApi, deleteServicesApi, deleteAwardsApi, postResumeApi, postVerifyByAdminApi, UniversityList, getRecommendation, patchRecommendation, deleteRecommendation, getLogoAPI, deleteProfessionalExperience, deleteProfessionalEducation, patchProfessionalEducation, patchProfessionalExperience, getEducationLogoAPI, getOtherProfessionalInfoAPIHelper, getPersonalProfileAPIHelper, getProfessionalProfileAPIHelper, getExperienceLogoAPI } from "../helpers/ProfileHelperApis";
import { ThumbDown } from "@material-ui/icons";


const initialState = {
    personalProfile: {},
    encryptedId: "",
    professionaProfile: {},
    videoResume: {},
    personalImage: {},
    personalCoverImage: {},
    professioanlImage: {},
    professionalCoverImage: {},
    educationBlob: {},
    certificateBlob: {},
    experienceBlob: {},
    projectBlob: {},
    serviceBlob: {},
    awardsBlob: {},
    healthBlob: {},
    isResumeChanged: false,
    // postPersonalProfile: {},
    // postPersonalProfileHobbies: {},
    personalProfileHobbies: {},
    // postPersonalProfileLanguages: {},
    personalProfileLanguages: {},
    generateAboutMe: {},
    ProfessionalgenerateAboutMe: {},
    visibilitydata: {},
    postHealth: {},
    healthData: {},
    // postFamilyData: {},
    FamilyData: {},
    deleteFamilydata: {},
    profileCompletion: {},
    HealthDocuments: {},
    educationData: {},
    certificateData: {},
    experienceData: {},
    projectData: {},
    serviceData: {},
    awardsData: {},
    ResumeData: {},
    deleteResumeData: {},
    professionalSkills: {},
    generateDescription: {},
    deleteEducationData: {},
    deleteCertificateData: {},
    deleteExperienceData: {},
    deleteProjectData: {},
    deleteAwardsData: {},
    deleteServiceData: {},
    universityData: {},
    Recommendation: {},
    updateRecommendation: {},
    deleteRecommendation: {},
    logoData: {},
    otherProfessionalInfo: [],
    personalProfileData:[],
    ProfessionalProfileData:[],
    // error: null,
};

export const getPersonalProfileDataReducer = createAsyncThunk('profile/getpersonalprofileData', async (_, thunkAPI) => {
    try {
        const response = await getPersonalProfileAPIHelper();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const getProfessionalProfileDataReducer = createAsyncThunk('profile/getProfessionalprofileData', async (_, thunkAPI) => {
    try {
        const response = await getProfessionalProfileAPIHelper();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const postPersonalProfileReducer = createAsyncThunk('profile/postpersonalprofile', async (Data, thunkAPI) => {
    try {
        const response = await postPersonalProfileApi(Data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const postProfessionalProfileReducer = createAsyncThunk('profile/postprofessionalprofile', async (Data, thunkAPI) => {
    try {
        const response = await postProfessionalProfileApi(Data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const postPersonalProfileHealthReducer = createAsyncThunk('profile/postpersonalhealthprofile', async (Data, thunkAPI) => {
    try {
        const response = await postPersonalProfileHealthApi(Data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const postPersonalProfileFamilyReducer = createAsyncThunk('profile/postpersonalfamilyprofile', async (Data, thunkAPI) => {
    try {
        const response = await postPersonalProfileFamilyApi(Data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const deletePersonalProfileFamilyReducer = createAsyncThunk('profile/deletepersonalfamilyprofile', async (id, thunkAPI) => {
    try {
        const response = await deletePersonalProfileFamilyApi(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});


export const getPersonalProfileFamilyReducer = createAsyncThunk('profile/getpersonalfamilyprofile', async (_, thunkAPI) => {
    try {
        const response = await getPersonalProfileFamilyApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const getPersonalHealthDocumentsReducer = createAsyncThunk('profile/getpersonalHealthDocumentprofile', async (_, thunkAPI) => {
    try {
        const response = await getProfileHealthDocumentsApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const getPersonalProfileHealthReducer = createAsyncThunk('profile/getpersonalhealthprofile', async (_, thunkAPI) => {
    try {
        const response = await getPersonalProfileHealthApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})
export const postPersonalProfileHobbiesReducer = createAsyncThunk('profile/postpersonalHobbiesprofile', async (Data, thunkAPI) => {
    try {
        const response = await postPersonalProfileHobbiesApi(Data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});


export const postPersonalProfileLanguagesReducer = createAsyncThunk('profile/postpersonalLanguagesprofile', async (Data, thunkAPI) => {
    try {
        const response = await postPersonalProfileLanguagesApi(Data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});


export const getPersonalProfileLanguagesReducer = createAsyncThunk('profile/getpersonalLanguagesprofile', async (_, thunkAPI) => {
    try {
        const response = await getPersonalProfileLanguagesApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const getProfileCompletionReducer = createAsyncThunk('profile/getprofileCompletion', async (_, thunkAPI) => {
    try {
        const response = await getProfileCompletionStatusApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const postPersonalProfileGenerateAboutMeReducer = createAsyncThunk('profile/postpersonalGenerateAboutMeprofile', async (Data, thunkAPI) => {
    try {
        const response = await postPersonalProfileGenerateAboutMeApi(Data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const postProfessionalProfileGenerateAboutMeReducer = createAsyncThunk('profile/postprofessionalGenerateAboutMeprofile', async (Data, thunkAPI) => {
    try {
        const response = await postProfessionalProfileGenerateAboutMeApi(Data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const getPersonalProfileHobbiesReducer = createAsyncThunk('profile/personalProfileHobbies',
    async (_, thunkAPI) => {
        try {
            const response = await getPersonalProfileHobbiesApi();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);

export const postPersonalProfileUpdateVisibilityReducer = createAsyncThunk('profile/personalProfileUpdateVisibility',
    async (data, thunkAPI) => {
        try {
            const response = await postPersonalProfileUpdateVisibilityApi(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);


export const getPersonalInfoReducer = createAsyncThunk('/personalProfileInfo',
    async (_, thunkAPI) => {
        try {
            const response = await getPersonalProfileApi();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);

export const getProfessionalInfoReducer = createAsyncThunk('/ProfessionaProfile', async (_, thunkAPI) => {
    try {
        const response = await getProfessionalInfoApi();
        return response;

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }

});


export const getVideoResumeReducer = createAsyncThunk('/getVideoResume', async (_, thunkAPI) => {
    try {

        const response = await getVideoResumeApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
})

export const postPersonalProfileImageReducer = createAsyncThunk(
    "personalImage/get",
    async (formData, thunkAPI) => {
        try {
            const response = await postPersonalProfilImageApi(formData);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const postPersonalCoverImageReducer = createAsyncThunk('/PersonalCoverImage', async (formData, thunkAPI) => {
    try {

        const response = await postPersonalProfilCoverImageApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
})

export const postProfessionalProfileImageReducer = createAsyncThunk('/professionaImage', async (formData, thunkAPI) => {
    try {

        const response = await postProfessionalProfilImageApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const postProfessionalCoverImageReducer = createAsyncThunk('/professionalCoverImage', async (formData, thunkAPI) => {
    try {

        const response = await postProfessionalProfilCoverImageApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
})

export const postEducationBlobReducer = createAsyncThunk('/postEducationBlob', async (formData, thunkAPI) => {
    try {
        const resposnse = await postEducationBlobApi(formData);
        return resposnse;

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const getEducationReducer = createAsyncThunk('Professional/getEducation', async (_, thunkAPI) => {
    try {
        const resposnse = await getEducationApi();
        return resposnse;

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});


export const postCertificateBlobReducer = createAsyncThunk('Professional/postCetificateBlob', async (formData, thunkAPI) => {
    try {
        const response = await postCertificateBlobApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const getCertificateReducer = createAsyncThunk('Professional/getCetificate', async (_, thunkAPI) => {
    try {
        const response = await getCertificateApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const postExperienceBlobReducer = createAsyncThunk('Professional/postExperienceBlob', async (formData, thunkAPI) => {
    try {
        const response = await postExperienceBlobApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const getExperienceReducer = createAsyncThunk('Professional/getExperience', async (_, thunkAPI) => {
    try {
        const response = await getExperienceApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})


export const postProjecteBlobReducer = createAsyncThunk('/postProjectBlob', async (formData, thunkAPI) => {
    try {
        const response = await postProjectBlobApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const getProjecteReducer = createAsyncThunk('professional/getProject', async (_, thunkAPI) => {
    try {
        const response = await getProjectApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const postServiceBlobReducer = createAsyncThunk('professional/postServiceBlob', async (formData, thunkAPI) => {
    try {
        const response = await postServiceBlobApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const getServiceReducer = createAsyncThunk('professional/getService', async (_, thunkAPI) => {
    try {
        const response = await getServiceApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const postAwardsBlobReducer = createAsyncThunk('profssional/postAwardsBlob', async (formData, thunkAPI) => {
    try {
        const response = await postAwardsBlobApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const getAwardsReducer = createAsyncThunk('professional/getAwards', async (_, thunkAPI) => {
    try {
        const response = await getAwardsApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const postHealthBlobReducer = createAsyncThunk('professional/postHealthBlob', async (formData, thunkAPI) => {
    try {
        const response = await postHealthBlobApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})


export const postProfessionalSkillsResucer = createAsyncThunk('professional/postprofessionalSkills', async (data, thunkAPI) => {
    try {
        const response = await postProfessionalSkillsApi(data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const getProfessionalSkillsReducer = createAsyncThunk('professional/professionalSkills', async (_, thunkAPI) => {
    try {
        const response = await getProfessionalSkillsApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const postResumeReducer = createAsyncThunk('professional/postResume', async (formData, thunkAPI) => {
    try {
        const response = await postResumeApi(formData);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const getResumeReducer = createAsyncThunk('professional/getResume', async (_, thunkAPI) => {
    try {
        const response = await getResumeApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})


export const deleteResumeReducer = createAsyncThunk('professional/deleteResume', async (id, thunkAPI) => {
    try {
        const response = await deleteResumeApi(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})


export const postGenerateDescriptionReducer = createAsyncThunk('professional/postGenerateDescription', async (prompt, thunkAPI) => {
    try {
        const response = await postGenerateDescriptionApi(prompt);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const deleteEducationReducer = createAsyncThunk('professional/deleteEducation', async (id, thunkAPI) => {
    try {
        const response = await deleteEducationApi(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const deleteCertificateReducer = createAsyncThunk('professional/deleteCertificate', async (id, thunkAPI) => {
    try {
        const response = await deleteCertificateApi(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})
export const deleteExperienceReducer = createAsyncThunk('professional/deleteExperience', async (id, thunkAPI) => {
    try {
        const response = await deleteExperienceApi(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const deleteProjectReducer = createAsyncThunk('professional/deleteProject', async (id, thunkAPI) => {
    try {
        const response = await deleteProjectApi(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const deleteServiceReducer = createAsyncThunk('professional/deleteServices', async (id, thunkAPI) => {
    try {
        const response = await deleteServicesApi(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const deleteAwardReducer = createAsyncThunk('professional/deleteAwards', async (id, thunkAPI) => {
    try {
        const response = await deleteAwardsApi(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
})

export const postVerifyByAdminReducer = createAsyncThunk('profile/VerifyByAdmin',
    async (data, thunkAPI) => {
        try {
            const response = await postVerifyByAdminApi(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    }
);

export const UniversityReducer = createAsyncThunk('/university',
    async (data, thunkAPI) => {
        try {
            const response = await UniversityList(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    }
);


export const getRecommendationReducer = createAsyncThunk('profile/recommedation',
    async (_, thunkAPI) => {
        try {
            const response = await getRecommendation();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);

export const patchRecommendationReducer = createAsyncThunk('profile/updaterecommedation',
    async (id, thunkAPI) => {
        try {
            const response = await patchRecommendation(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);


export const deleteRecommendationReducer = createAsyncThunk('profile/deleterecommedation',
    async (id, thunkAPI) => {
        try {
            const response = await deleteRecommendation(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);

export const getLogoReducer = createAsyncThunk('Logo/data',
    async (data, thunkAPI) => {
        try {
            const response = await getLogoAPI(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);


export const getEducationLogoReducer = createAsyncThunk('Logo/Educationdata',
    async (data, thunkAPI) => {
        try {
            const response = await getEducationLogoAPI(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);

export const getExperienceLogoReducer = createAsyncThunk('Logo/Experiencedata',
    async (data, thunkAPI) => {
        try {
            const response = await getExperienceLogoAPI(data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);

export const deleteProfessionalExperienceReducer = createAsyncThunk('profile/deleteProfessionalExperience',
    async (id, thunkAPI) => {
        try {
            const response = await deleteProfessionalExperience(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);

export const deleteProfessionalEducationReducer = createAsyncThunk('profile/deleteProfessionalEducationReducer',
    async (id, thunkAPI) => {
        try {
            const response = await deleteProfessionalEducation(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);

export const patchProfessionalEducationReducer = createAsyncThunk(
    'profile/patchProfessionalEducation',
    async ({ id, data }, thunkAPI) => {
        try {
            const response = await patchProfessionalEducation(id, data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const patchProfessionalExperienceReducer = createAsyncThunk('profile/patchProfessionalExperience',
    async ({ id, data }, thunkAPI) => {
        try {
            const response = await patchProfessionalExperience(id, data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);

export const getOtherProfessionalInfo = createAsyncThunk('Logo/Educationdata',
    async (payload, thunkAPI) => {
        try {
            const response = await getOtherProfessionalInfoAPIHelper(payload);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }

    },
);


const ProfileSlice = createSlice({
    name: 'Profile',
    initialState,
    reducers: {
        clearProfileState: (state) => {
            state.personalProfile = {};
            state.professionaProfile = {};
            state.videoResume = {};
            state.FamilyData = {};
            state.personalProfileHobbies = {};
            state.personalProfileLanguages = {};
            state.healthData = {};
            state.HealthDocuments = {};
            state.healthBlob = {}
            state.serviceData = {}
            state.educationData = {}
            state.experienceData = {}
            state.certificateData = {}
            state.projectData = {}
            state.awardsData = {}
            state.professionalSkills = {}
            state.ResumeData = {}
            state.updateRecommendation = {}
            state.encryptedId = ""
            state.Recommendation = {}
            // state.error = null;
        },
        setIsResumeChange: (state, action) => {
            state.isResumeChanged = action?.payload;
        },
        setEncryptedId: (state, action) => {
            state.encryptedId = action?.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPersonalInfoReducer.fulfilled, (state, action) => {
                state.personalProfile = action.payload;
                // console.log("Personal data", JSON.stringify(action));
                // state.error = null;
            })
            .addCase(getPersonalInfoReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getProfessionalInfoReducer.fulfilled, (state, action) => {
                state.professionaProfile = action.payload.data;
                // state.error = null;
            })
            .addCase(getProfessionalInfoReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getVideoResumeReducer.fulfilled, (state, action) => {
                state.videoResume = action.payload.data;
                // console.log('getVideoResumeReducer', JSON.stringify(action));
            })
            .addCase(getVideoResumeReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            // .addCase(postPersonalProfileImageReducer.fulfilled, (state, action) => {
            //     state.personalImage = action.payload;
            // })
            // .addCase(postPersonalProfileImageReducer.rejected, (state, action) => {
            //     state.error = action.error.message;
            // })
            // .addCase(postProfessionalProfileImageReducer.fulfilled, (state, action) => {
            //     state.professioanlImage = action.payload;
            // })
            // .addCase(postProfessionalProfileImageReducer.rejected, (state, action) => {
            //     state.error = action.error.message;
            // })
            // .addCase(postPersonalCoverImageReducer.fulfilled, (state, action) => {
            //     state.personalCoverImage = action.payload;
            // })
            // .addCase(postPersonalCoverImageReducer.rejected, (state, action) => {
            //     state.error = action.error.message;
            // })
            // .addCase(postProfessionalCoverImageReducer.fulfilled, (state, action) => {
            //     state.professionalCoverImage = action.payload;
            // })
            // .addCase(postProfessionalCoverImageReducer.rejected, (state, action) => {
            //     state.error = action.error.message;
            // })
            .addCase(postEducationBlobReducer.fulfilled, (state, action) => {
                state.educationBlob = action.payload;
            })
            .addCase(postEducationBlobReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postCertificateBlobReducer.fulfilled, (state, action) => {
                state.certificateBlob = action.payload;
            })
            .addCase(postCertificateBlobReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postExperienceBlobReducer.fulfilled, (state, action) => {
                state.experienceBlob = action.payload;
            })
            .addCase(postExperienceBlobReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postProjecteBlobReducer.fulfilled, (state, action) => {
                state.projectBlob = action.payload;
            })
            .addCase(postProjecteBlobReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postServiceBlobReducer.fulfilled, (state, action) => {
                state.serviceBlob = action.payload;
            })
            .addCase(postServiceBlobReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postAwardsBlobReducer.fulfilled, (state, action) => {
                state.awardsBlob = action.payload;
            })
            .addCase(postAwardsBlobReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postHealthBlobReducer.fulfilled, (state, action) => {
                state.healthBlob = action.payload;
            })
            .addCase(postHealthBlobReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })

            // .addCase(postPersonalProfileReducer.fulfilled, (state, action) => {
            //     state.postPersonalProfile = action.payload;
            // })
            // .addCase(postPersonalProfileReducer.rejected, (state, action) => {
            //     state.error = action.error.message;
            // })
            // .addCase(postPersonalProfileHobbiesReducer.fulfilled, (state, action) => {
            //     state.postPersonalProfileHobbies = action.payload;
            // })
            // .addCase(postPersonalProfileHobbiesReducer.rejected, (state, action) => {
            //     state.error = action.error.message;
            // })

            .addCase(getPersonalProfileHobbiesReducer.fulfilled, (state, action) => {
                state.personalProfileHobbies = action.payload;
            })
            .addCase(getPersonalProfileHobbiesReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            // .addCase(postPersonalProfileLanguagesReducer.fulfilled, (state, action) => {
            //     state.postPersonalProfileLanguages = action.payload;
            // })
            // .addCase(postPersonalProfileLanguagesReducer.rejected, (state, action) => {
            //     state.error = action.error.message;
            // })
            .addCase(getPersonalProfileLanguagesReducer.fulfilled, (state, action) => {
                state.personalProfileLanguages = action.payload;
            })
            .addCase(getPersonalProfileLanguagesReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postPersonalProfileGenerateAboutMeReducer.fulfilled, (state, action) => {
                state.generateAboutMe = action.payload;
            })
            .addCase(postPersonalProfileGenerateAboutMeReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postPersonalProfileUpdateVisibilityReducer.fulfilled, (state, action) => {
                state.visibilitydata = action.payload;
            })
            .addCase(postPersonalProfileUpdateVisibilityReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postPersonalProfileHealthReducer.fulfilled, (state, action) => {
                state.postHealth = action.payload;
            })
            .addCase(postPersonalProfileHealthReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getPersonalProfileHealthReducer.fulfilled, (state, action) => {
                state.healthData = action.payload;
            })
            .addCase(getPersonalProfileHealthReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            // .addCase(postPersonalProfileFamilyReducer.fulfilled, (state, action) => {
            //     state.postFamilyData = action.payload;
            // })
            // .addCase(postPersonalProfileFamilyReducer.rejected, (state, action) => {
            //     state.error = action.error.message;
            // })
            .addCase(getPersonalProfileFamilyReducer.fulfilled, (state, action) => {
                state.FamilyData = action.payload;
            })
            .addCase(getPersonalProfileFamilyReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(deletePersonalProfileFamilyReducer.fulfilled, (state, action) => {
                state.deleteFamilydata = action.payload;
            })
            .addCase(deletePersonalProfileFamilyReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getProfileCompletionReducer.fulfilled, (state, action) => {
                state.profileCompletion = action.payload;
            })
            .addCase(getProfileCompletionReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getPersonalHealthDocumentsReducer.fulfilled, (state, action) => {
                state.HealthDocuments = action.payload;
            })
            .addCase(getPersonalHealthDocumentsReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(getEducationReducer.fulfilled, (state, action) => {
                state.educationData = action.payload;
            })
            .addCase(getEducationReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(getCertificateReducer.fulfilled, (state, action) => {
                state.certificateData = action.payload;
            })
            .addCase(getCertificateReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(getExperienceReducer.fulfilled, (state, action) => {
                state.experienceData = action.payload;
            })
            .addCase(getExperienceReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(getProjecteReducer.fulfilled, (state, action) => {
                state.projectData = action.payload;
            })
            .addCase(getProjecteReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(getServiceReducer.fulfilled, (state, action) => {
                state.serviceData = action.payload;
            })
            .addCase(getServiceReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(getAwardsReducer.fulfilled, (state, action) => {
                state.awardsData = action.payload;
            })
            .addCase(getAwardsReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(getResumeReducer.fulfilled, (state, action) => {
                state.ResumeData = action.payload;
            })
            .addCase(getResumeReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(deleteResumeReducer.fulfilled, (state, action) => {
                state.deleteResumeData = action.payload;
            })
            .addCase(deleteResumeReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getProfessionalSkillsReducer.fulfilled, (state, action) => {
                state.professionalSkills = action.payload;
            })
            .addCase(getProfessionalSkillsReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postGenerateDescriptionReducer.fulfilled, (state, action) => {
                state.generateDescription = action.payload;
            })
            .addCase(postGenerateDescriptionReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(postProfessionalProfileGenerateAboutMeReducer.fulfilled, (state, action) => {
                state.ProfessionalgenerateAboutMe = action.payload;
            })
            .addCase(postProfessionalProfileGenerateAboutMeReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(deleteEducationReducer.fulfilled, (state, action) => {
                state.deleteEducationData = action.payload;
            })
            .addCase(deleteEducationReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(deleteExperienceReducer.fulfilled, (state, action) => {
                state.deleteExperienceData = action.payload;
            })
            .addCase(deleteExperienceReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(deleteCertificateReducer.fulfilled, (state, action) => {
                state.deleteCertificateData = action.payload;
            })
            .addCase(deleteCertificateReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(deleteProjectReducer.fulfilled, (state, action) => {
                state.deleteProjectData = action.payload;
            })
            .addCase(deleteProjectReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(deleteAwardReducer.fulfilled, (state, action) => {
                state.deleteProjectData = action.payload;
            })
            .addCase(deleteAwardReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(deleteServiceReducer.fulfilled, (state, action) => {
                state.deleteServiceData = action.payload;
            })
            .addCase(deleteServiceReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(UniversityReducer.fulfilled, (state, action) => {
                state.universityData = action.payload;
            })
            .addCase(UniversityReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getRecommendationReducer.fulfilled, (state, action) => {
                state.Recommendation = action.payload;
            })
            .addCase(getRecommendationReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(patchRecommendationReducer.fulfilled, (state, action) => {
                state.updateRecommendation = action.payload;
            })
            .addCase(patchRecommendationReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(deleteRecommendationReducer.fulfilled, (state, action) => {
                state.deleteRecommendation = action.payload;
            })
            .addCase(deleteRecommendationReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(getLogoReducer.fulfilled, (state, action) => {
                state.logoData = action.payload;
            })
            .addCase(getLogoReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(getOtherProfessionalInfo.fulfilled, (state, action) => {
                // console.log("HamaraData", action.payload?.data )
                state.otherProfessionalInfo = action.payload?.data;
            })
            .addCase(getOtherProfessionalInfo.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getPersonalProfileDataReducer.fulfilled, (state, action) => {
                // console.log("HamaraData", action.payload?.data )
                state.personalProfileData = action.payload?.data;
            })
            .addCase(getPersonalProfileDataReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
    },
});

export const { clearProfileState, setIsResumeChange, setEncryptedId } = ProfileSlice.actions;

export default ProfileSlice.reducer;